import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.push.js";
import { onMounted, onBeforeUnmount, ref } from 'vue';
import * as THREE from 'three';
export default {
  __name: 'star',
  setup: function setup(__props) {
    var starCanvas = ref(null);
    var scene, camera, renderer, stars, animationId;
    function generateCircleTexture() {
      var size = 64;
      var canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      var ctx = canvas.getContext('2d');
      var gradient = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
      gradient.addColorStop(0, 'rgba(5,130,247,1)');
      gradient.addColorStop(1, 'rgba(5,130,247,0)');
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.fill();
      return new THREE.CanvasTexture(canvas);
    }
    var mouse = {
      x: 0,
      y: 0
    };
    function onMouseMove(event) {
      mouse.x = event.clientX / window.innerWidth * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }
    onMounted(function () {
      var canvas = starCanvas.value;
      var width = window.innerWidth;
      var height = window.innerHeight;
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(75, width / height, 1, 2000);
      camera.position.z = 500;
      var geometry = new THREE.BufferGeometry();
      var positions = [];
      var starCount = 1000;
      for (var i = 0; i < starCount; i++) {
        positions.push((Math.random() - 0.5) * 2000, (Math.random() - 0.5) * 2000, (Math.random() - 0.5) * 2000);
      }
      geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
      var material = new THREE.PointsMaterial({
        size: 6,
        map: generateCircleTexture(),
        transparent: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending
      });
      stars = new THREE.Points(geometry, material);
      scene.add(stars);
      renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        alpha: true
      });
      renderer.setSize(width, height);
      renderer.setPixelRatio(window.devicePixelRatio);
      window.addEventListener('mousemove', onMouseMove);
      animate();
    });
    function animate() {
      stars.rotation.x += 0.003;
      stars.rotation.y += 0.003;
      stars.rotation.x += mouse.y * 0.005;
      stars.rotation.y += mouse.x * 0.005;
      renderer.render(scene, camera);
      animationId = requestAnimationFrame(animate);
    }
    onBeforeUnmount(function () {
      cancelAnimationFrame(animationId);
      window.removeEventListener('mousemove', onMouseMove);
      renderer.dispose();
    });
    return {
      __sfc: true,
      starCanvas: starCanvas,
      scene: scene,
      camera: camera,
      renderer: renderer,
      stars: stars,
      animationId: animationId,
      generateCircleTexture: generateCircleTexture,
      mouse: mouse,
      onMouseMove: onMouseMove,
      animate: animate,
      onMounted: onMounted,
      onBeforeUnmount: onBeforeUnmount,
      ref: ref,
      THREE: THREE
    };
  }
};